import { ModalService } from './../../../../commons/services/modal.service';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventsConstants } from '../../../../commons/constants/event-constants';
import { LoginModel } from '../../models/login-model';
import { AuthService } from '../../services/auth.service';
import { CountriesConstants } from '../../../../commons/constants/countries-constant';
import { CountryModel } from '../../../../commons/models/country-model';
import { CountryService } from '../../../../commons/services/country.service';
import { CountriesEnum } from '../../../../commons/enums/countries.enum';
import { BaseTranslateService } from '../../../../commons/services/base-translate.service';
import { environment } from '../../../../../environments/environment';
import * as CryptoJS from 'crypto-js';
import { TranslatedTextKey } from '../../contants/translate-key.constants';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { GlobalConstants } from '../../../../commons/constants/global-constants';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GetFederatedTokenModel } from '../../models/auth-federated-token-model';
import { LoginResponseModel } from '../../models/login-response.model';
import { ProgreesBarService } from '../../../../commons/services/progrees-bar.service';
import { AppState } from '../../../../app.state';
import { Store, select } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { ROUTER_LOGIN } from '../../../../commons/constants/router/router.constant';
import { UserGraphQLService } from '../../../../graphQL/services/user/userGraphQL.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthConstants } from '../../contants/auth-constants';
import { TranslateService } from '@ngx-translate/core';

// export function HttpLoaderFactory(httpClient: HttpClient) {
//   return new TranslateHttpLoader(httpClient, '/assets/i18n/', '.json');
// }
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  public form = new FormGroup({
    username: new FormControl("", [Validators.required, this.validEmail]),
    password: new FormControl("", [Validators.required])
  });
  urlRedirect: string = '';
  public countries: CountryModel[] = CountriesConstants;
  public showPassword: boolean = false;
  private _authSubscription: Subscription = new Subscription;
  private _onChangeLanguage: Subscription = new Subscription;
  translatedTextKeyLogin = TranslatedTextKey;
  backgroundImage = environment.backgroundImage;
  authCode: string = '';
  state: any = null;

  private readonly jwtHelper = inject(JwtHelperService)
  constructor(

    private store: Store<AppState>,
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _countryService: CountryService,
    public _baseTranslateService: BaseTranslateService,
    private _recaptchaV3Service: ReCaptchaV3Service,
    private progreesBarService: ProgreesBarService,
    private messageService: MessageService,
    private router: Router,
    public _userService: UserGraphQLService,
    public modalService: ModalService,
    public translate: TranslateService
  ) {
    this.progreesBarService.showProgressBar();
    this._activatedRoute.queryParams.subscribe(
      (params) => {
        const { urlRedirect, code, error_description } = params;

        // Handle URL redirection
        if (urlRedirect) {
          this.urlRedirect = urlRedirect;
        }

        // Handle federated login
        if (code) {
          this.federatedLogin(code);
        }

        // Handle error description
        if (error_description) {
          // Use async translation loading to ensure translations are ready
          this.translate.get(['mcfLoginShell.login.aadCustomUserSignInError', 
                             'mcfLoginShell.login.aadCustomUserLogInError',
                             'mcfLoginShell.login.notification']).subscribe(translations => {
            const errorMessages: { [key: string]: string } = {
              AAD_Custom_userSignInError: translations['mcfLoginShell.login.aadCustomUserSignInError'],
              AAD_Custom_userLogInError: translations['mcfLoginShell.login.aadCustomUserLogInError']
            };

            for (const [key, message] of Object.entries(errorMessages)) {
              if (error_description.includes(key)) {
                this.modalService.toggleModal(
                  translations['mcfLoginShell.login.notification'].toString().toUpperCase(),
                  message,
                  true,
                  'info'
                );
                break;
              }
            }
          });
        }
      }
    );

    this.resetForm();
  }

providers: any[] = [];
  getStoreConfig() {
    this._userService.getStoreConfig(environment.storeIdComplete).subscribe({
      next: (data: any) => {

        this._userService.storeConfig = data.getStoreInfo;


      if (data.getStoreInfo?.authProviders) {
        this.providers = data.getStoreInfo.authProviders.filter((p: any) => p.isEnabled);
      }
        this.progreesBarService.hideProgressBar();
      },
    });
  }


  ngOnInit(): void {
    this.getStoreConfig();
    this.store.select((state) => state).subscribe(state => {
      this.state = state;
    });

  }

  ngOnDestroy(): void {
    this._authSubscription?.unsubscribe();
    this._onChangeLanguage?.unsubscribe();
  }

  public onSelectedCountry(): void {
    const countryId: string = this.form.get("country")!.value;
    // if (countryId === CountriesEnum.Usa) {
    //   this._baseTranslateService.setLangEn();
    // } else {
    //   this._baseTranslateService.setLangEs();
    // }

    this._baseTranslateService.setLangEs();
  }

  public onSubmit(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    let login = new LoginModel();
    let replaceUserName = this.form.controls['username'].value!.replace(/\s/g, "");
    let replacePassword = this.form.controls['password'].value!.replace(/\s/g, "");
    login.username = replaceUserName;
    login.password = this.encrypt(replacePassword);
    login.country = "5"
    this.getToken(login);
  }

  public handleKeyUp(e: { keyCode: number; }): void {
    if (e.keyCode === 13) {
      this.onSubmit();
    }
  }

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }

  private getToken(login: LoginModel): void {
    this.progreesBarService.showProgressBar();
    this._recaptchaV3Service.execute(GlobalConstants.Login).subscribe({
      next: (token) => {
        login.captchaToken = token;
        login.userType = AuthConstants.ExternalUserTypeParam;
        login.storeId = environment.storeId;
        login.tenantId = environment.tenantId;
        this._authSubscription = this._authService.internalLogin(login).subscribe({
          next: (response) => {
            this.progreesBarService.hideProgressBar();
            if (response?.data?.access_token && response?.data?.access_token !== "") {

              this.processTokenSuccessResponse(response.data, login.country)
            }
            else {
              this.modalService.toggleModal(
                this.translate.instant('mcfLoginShell.login.notification').toString().toUpperCase(),
                this.translate.instant('mcfLoginShell.login.invalidCredentials'),
                true,
                'info'
              );

            }
          },
          error: (response: string) => {
            this.progreesBarService.hideProgressBar();
            let errormessage = this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString();
            if (TranslatedTextKey.hasOwnProperty(response)) {
              let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
              errormessage = this.translate.instant(key).toString();
            }
            this.messageService.add({ severity: 'error', detail: errormessage });
          }
        });

      },
      error: (err) => {
        this.progreesBarService.hideProgressBar();
        this.messageService.add({ severity: 'error', detail: this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString() });
      }
    });
  }
  private processTokenSuccessResponse(loginResponseModel: LoginResponseModel, country: string): void {
    this._countryService.setCountryId(country);
    window.location.href = this.buildRedirectUrl(
      loginResponseModel.access_token,
      loginResponseModel.refresh_token
    );
  }

  private buildRedirectUrl(accessToken: string, refreshToken?: string): string {
    const target = this.urlRedirect && this.urlRedirect !== ''
      ? this.urlRedirect
      : environment.DefaultRedirect;

    if (target.includes('{BearerToken}')) {
      return target.replace('{BearerToken}', accessToken);
    }

    const separator = target.includes('?') ? '&' : '?';
    let result = `${target}${separator}request=${accessToken}`;

    if(target != environment.DefaultRedirect){
      return result;
    }

    result = `${target}${separator}idToken=${accessToken}`;
    if (refreshToken) {
      result += `&refreshToken=${refreshToken}`;
    }
    return result;
  }
  private resetForm(): void {
    this.form = new FormGroup({
      username: new FormControl("", [Validators.required, this.validEmail]),
      password: new FormControl("", [Validators.required])
    });
  }


  private showErrorMessage(errorMessage: string = "") {
    this.progreesBarService.hideProgressBar();
    window.dispatchEvent(new CustomEvent(EventsConstants.SHOW_ERROR, {
      detail: errorMessage ? errorMessage : "Error"
    })
    );
  }

  public validEmail(control: FormControl): { [key: string]: boolean } {
    const nameRegexp: RegExp = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
    if (control.value && !nameRegexp.test(control.value)) {
      return { 'invalidEmail': true };
    }
    return null;
  }

  private encrypt(value: string): string {

    var key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var iv = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }

  /**
 *This method handle the click on the diferent buttons of federatedlogin to get the autorization code to make the login
 *
 * @param {string} idp
 * @memberof LoginComponent
 */
  public getAuthCode(idp: string): void {
    this.progreesBarService.showProgressBar();
    this._authSubscription = this._authService.getAuthCodeUrl(idp, true).subscribe({
      next: (response) => {
        if (response?.data !== "") {
          this.progreesBarService.hideProgressBar();
          localStorage.setItem("idp", idp);
        }
      },
      error: (response: string) => {
        this.progreesBarService.hideProgressBar();
        // let errormessage = this._baseTranslateService.getText(TranslatedTextKey.ERROR_MESSAGE500)
        let errormessage = this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString();
        if (TranslatedTextKey.hasOwnProperty(response)) {
          let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
          errormessage = this.translate.instant(key).toString();
        }

        this.messageService.add({ severity: 'error', detail: errormessage });
      }
    });
  }

  public federatedLogin(code: string): void {
    this.progreesBarService.showProgressBar();
    let getFederatedTokenModel = new GetFederatedTokenModel();
    getFederatedTokenModel.AuthCode = code;
    getFederatedTokenModel.idp = localStorage.getItem("idp");
    this._authSubscription = this._authService.getFederatedToken(getFederatedTokenModel).subscribe({
      next: (response) => {
        if (response?.data !== "") {
          let responseB2C: any = response.data;
          this.progreesBarService.hideProgressBar();

          let decodeToken = this.getDecodedAccessToken(responseB2C.access_token);
          if (decodeToken.roles == "" || decodeToken.roles == null) {
            this._userService.typeUser = 2;
            this._userService.userInfo = {
              email: decodeToken.email || '',
              name: decodeToken.given_name || '',
              lastName: decodeToken.family_name || ''
            };
            this.router.navigate([ROUTER_LOGIN.REGISTER.FORM]);

          } else {
            window.location.href = this.buildRedirectUrl(
              responseB2C.access_token,
              responseB2C.refresh_token
            );
          }


        }
      },
      error: (response: string) => {
        this.progreesBarService.hideProgressBar();
        let errormessage = this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString();
        if (TranslatedTextKey.hasOwnProperty(response)) {
          let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
          errormessage = this.translate.instant(key).toString();
        }
        this.messageService.add({ severity: 'error', detail: errormessage });
      }
    });

  }

  private onChangeLanguage() {
    this._onChangeLanguage = this._baseTranslateService.onChangeLanguage()
      .subscribe();
  }

  getDecodedAccessToken(token: string | any): any {
    try {
      return this.jwtHelper.decodeToken(token);
    } catch (Error) {
      return null;
    }
  }

  goRegisterForm() {
    this._userService.typeUser = 1;
    this.router.navigate([ROUTER_LOGIN.CREATE_ACCOUNT.FORM]);
  }

}
